// extracted by mini-css-extract-plugin
export var colorSquare = "_m3-0";
export var danger = "_m3-5";
export var lightPink = "_m3-8";
export var neutralBlue = "_m3-7";
export var neutralYellow = "_m3-6";
export var normal = "_m3-1";
export var primary = "_m3-2";
export var primaryLight = "_m3-3";
export var solidBlack = "_m3-g";
export var solidGreen = "_m3-b";
export var solidLightBlue = "_m3-d";
export var solidNavy = "_m3-c";
export var solidOrange = "_m3-f";
export var solidPink = "_m3-e";
export var solidRed = "_m3-9";
export var solidYellow = "_m3-a";
export var success = "_m3-4";